import homeImg from "src/assets/icons/home.png"
import { Theme } from "@mui/material"
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked"
import ROUTE_PATHS from "src/routes/route-path"

const ganerateSidebarItems = ({ theme }: { theme: Theme }) => {
  const filter = theme.palette.mode === "dark" ? "invert(1)" : "invert(0)"

  const items = [
    {
      icon: <Icon src={homeImg} filter={filter} />,
      title: "Dashboard",
      permission: null,
      href: ROUTE_PATHS.DASHBOARD
    },
    {
      icon: <RadioButtonUncheckedIcon sx={{ fontSize: "0.75rem" }} />,
      title: "Invoice",
      permission: null,
      href: ROUTE_PATHS.INVOICE
    },
    {
      icon: <RadioButtonUncheckedIcon sx={{ fontSize: "0.75rem" }} />,
      title: "Container",
      permission: null,
      href: ROUTE_PATHS.CONTAINER
    },
    {
      icon: <RadioButtonUncheckedIcon sx={{ fontSize: "0.75rem" }} />,
      title: "Utilities",
      permission: null,
      children: [
        {
          icon: <RadioButtonUncheckedIcon sx={{ fontSize: "0.75rem" }} />,
          title: "Customer",
          permission: null,
          href: ROUTE_PATHS.CUSTOMER
        },
        {
          icon: <RadioButtonUncheckedIcon sx={{ fontSize: "0.75rem" }} />,
          title: "Invoice Particular",
          permission: null,
          href: ROUTE_PATHS.INVOICE_PARTICULAR
        },
        {
          icon: <RadioButtonUncheckedIcon sx={{ fontSize: "0.75rem" }} />,
          title: "Consignment",
          permission: null,
          href: ROUTE_PATHS.CONSIGNMENT
        },
        {
          icon: <RadioButtonUncheckedIcon sx={{ fontSize: "0.75rem" }} />,
          title: "Shipment Status",
          permission: null,
          href: ROUTE_PATHS.SHIPMENT_STATUS
        },
        {
          icon: <RadioButtonUncheckedIcon sx={{ fontSize: "0.75rem" }} />,
          title: "Container Type",
          permission: null,
          href: ROUTE_PATHS.CONTAINER_TYPE
        },
        {
          icon: <RadioButtonUncheckedIcon sx={{ fontSize: "0.75rem" }} />,
          title: "Descriptions",
          permission: null,
          href: ROUTE_PATHS.DESCRIPTIONS
        },
        {
          icon: <RadioButtonUncheckedIcon sx={{ fontSize: "0.75rem" }} />,
          title: "Port",
          permission: null,
          href: ROUTE_PATHS.PORT
        },
        {
          icon: <RadioButtonUncheckedIcon sx={{ fontSize: "0.75rem" }} />,
          title: "Shipper",
          permission: null,
          href: ROUTE_PATHS.SHIPPER
        },
        {
          icon: <RadioButtonUncheckedIcon sx={{ fontSize: "0.75rem" }} />,
          title: "Vendor",
          permission: null,
          href: ROUTE_PATHS.VENDOR
        },
        {
          icon: <RadioButtonUncheckedIcon sx={{ fontSize: "0.75rem" }} />,
          title: "Shipping Line",
          permission: null,
          href: ROUTE_PATHS.SHIPPING_LINE
        },
        {
          icon: <RadioButtonUncheckedIcon sx={{ fontSize: "0.75rem" }} />,
          title: "Vessel",
          permission: null,
          href: ROUTE_PATHS.VESSEL
        }
      ]
    }
  ]

  return items
}

export { ganerateSidebarItems }

// addons supportive
const Icon = ({ src, filter, style }: { src: string; filter: string; style?: React.CSSProperties }) => {
  return (
    <img
      src={src}
      alt="icon"
      width="16px"
      style={{
        filter,
        ...style
      }}
    />
  )
}
// End of Selection
//   {
//     icon: <Icon src={settingsImg} filter={filter} />,
//     title: "Settings",
//     href: "/app/settings",
//     children: [
//       // notification add in settings here
//       { icon: <Icon src={activityImg} filter={filter} />, title: "Notifications", href: "/app/notifications" },
//       { icon: <Icon src={settingsImg} filter={filter} />, title: "Add Settings", href: "/app/settings?add=true" },
//       { icon: <SvgIcon src={storeIcon} />, title: "Locations", href: "/app/settings/locations" }
//     ]
//   }
// ]
